
<div  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane" style="text-align: right;cursor: pointer;">
    <i class="material-icons __close-button" (click)="_dialogRef.close()" matTooltip="Close Popup">close</i>
  </div>
<div
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  class="dialog-container"
>
  <!-- <div cdkDragHandle class="dialog-header">
    <h2>Draggable MatDialog</h2>
  </div> -->

  <div class="dialog-body" cdkDragHandle>
   <img [src]="ImageSrc" alt="Inspection Image" width="150" style="object-fit: contain; width: 150%;cursor: grab;" />
  </div>
</div>